import { Application } from "@hotwired/stimulus"
import RoadmapViewController from "./roadmap_view_controller"
import PaginationLoadingController from "./pagination_loading_controller"
import SubscribeCategorySelectController from "./subscribe_category_select_controller"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Register controllers
application.register("roadmap-view", RoadmapViewController)
application.register("pagination-loading", PaginationLoadingController)
application.register("subscribe-category-select", SubscribeCategorySelectController)

export { application }
